import React from 'react';
import { useTranslation } from 'react-i18next';
import { Trans } from 'react-i18next';
import './Privacy.css';

const Privacy = () => {
  const { t } = useTranslation();
  
  return (
    <div className="privacy container">
      <h1>{t('privacy.title')}</h1>
      
      <div style={{marginTop:"0.5rem"}}>
      <div className="privacy-section">
        <Trans i18nKey="privacy.sections.summary_desc">
        </Trans>
      </div>
      
        <div className="privacy-section">
          <h3>{t('privacy.sections.collect')}</h3>
          <Trans i18nKey="privacy.sections.collect_desc">
          </Trans>
          <ul>
            <li style={{marginTop:"0.5rem"}}>
              <a href='https://www.google.com/policies/privacy/'>{t('privacy.sections.service_play_services')}</a>
            </li>
            <li style={{marginTop:"0.5rem"}}>
              <a href='https://support.google.com/admob/answer/6128543?hl=en'>{t('privacy.sections.service_admob')}</a>
            </li>
          </ul>

        </div>
        
        <div className="privacy-section">
          <h3>{t('privacy.sections.log')}</h3>
          <Trans i18nKey="privacy.sections.log_desc">
          </Trans>
        </div>

        <div className="privacy-section">
          <h3>{t('privacy.sections.cookies')}</h3>
          <Trans i18nKey="privacy.sections.cookies_desc">
          </Trans>
        </div>
        
        <div className="privacy-section">
          <h3>{t('privacy.sections.providers')}</h3>
          <Trans i18nKey="privacy.sections.providers_desc">
          </Trans>
          <ul>
            <li style={{marginTop:"0.5rem"}}>
              <Trans i18nKey="privacy.sections.providers_desc1">
              </Trans>
            </li>
            <li style={{marginTop:"0.5rem"}}>
              <Trans i18nKey="privacy.sections.providers_desc2">
              </Trans>
            </li>
            <li style={{marginTop:"0.5rem"}}>
              <Trans i18nKey="privacy.sections.providers_desc3">
              </Trans>
            </li>
            <li style={{marginTop:"0.5rem"}}>
              <Trans i18nKey="privacy.sections.providers_desc4">
              </Trans>
            </li>
          </ul>
          <p style={{marginTop:"0.5rem"}}>
            <Trans i18nKey="privacy.sections.providers_desc_end">
            </Trans>
          </p>
        </div>
        
        <div className="privacy-section">
          <h3>{t('privacy.sections.security')}</h3>          
          <Trans i18nKey="privacy.sections.security_desc">
          </Trans>
        </div>
        
        
        <div className="privacy-section">
          <h3>{t('privacy.sections.links')}</h3>
          <Trans i18nKey="privacy.sections.links_desc">
          </Trans>
        </div>

        
        <div className="privacy-section">
          <h3>{t('privacy.sections.children')}</h3>
          <Trans i18nKey="privacy.sections.children_desc">
          </Trans>
        </div>
        <div className="privacy-section">
          <h3>{t('privacy.sections.changes')}</h3>
          <Trans i18nKey="privacy.sections.changes_desc">
          </Trans>
        </div>

        <div className="privacy-section">
          <h3>{t('privacy.sections.contact')}</h3>
          <Trans i18nKey="privacy.sections.contact_desc">
          </Trans>  
        </div>
      </div>
      <br/>
      
      <p>{t('privacy.updated')}: 25<sup>th</sup> August 2021</p>
      
    </div>
  );
};

export default Privacy;